export interface AdvertiseLinkEntry {
    Portal?: string
    Title?: string
    Link?: string
    Trakheesi_id?: string
    Status?: string
    Comment?: string | null
    Feedback?: string | null
    IsDisabled?: boolean
    Disabled?: boolean
    [key: string]: any
}

export interface IndexedAdvertiseLink extends AdvertiseLinkEntry {
    __sourceIndex: number
}

const STATUS_VALUES = ['Approved', 'Rejected', 'In-process'] as const

export const normalizeLinkStatus = (status: unknown): string => {
    if (typeof status === 'string' && (STATUS_VALUES as readonly string[]).includes(status)) {
        return status
    }
    return 'In-process'
}

export const normalizeLinksArray = (links: unknown): AdvertiseLinkEntry[] => {
    if (Array.isArray(links)) {
        return links.filter((item) => item != null && typeof item === 'object') as AdvertiseLinkEntry[]
    }
    if (links != null && typeof links === 'object') {
        return [links as AdvertiseLinkEntry]
    }
    return []
}

export const isPortalLinkEntry = (link: AdvertiseLinkEntry): boolean => {
    const hasUrl = typeof link?.Link === 'string' && link.Link.trim().length > 0
    const hasPortalField = typeof link?.Portal === 'string' && link.Portal.trim().length > 0
    const title = typeof link?.Title === 'string' ? link.Title.trim().toLowerCase() : ''
    const hasPortalTitle = title.length > 0 && title !== 'trakheesi'
    return hasUrl || hasPortalField || hasPortalTitle
}

export const getPortalLabel = (link: AdvertiseLinkEntry): string => {
    if (typeof link?.Portal === 'string' && link.Portal.trim().length > 0) {
        return link.Portal.trim()
    }
    if (typeof link?.Title === 'string' && link.Title.trim().length > 0) {
        return link.Title.trim()
    }
    return 'Portal'
}

export const getLinkComment = (link: AdvertiseLinkEntry): string => {
    if (typeof link?.Comment === 'string') {
        return link.Comment
    }
    if (typeof link?.Feedback === 'string') {
        return link.Feedback
    }
    return ''
}

export const getLinkDisabled = (link: AdvertiseLinkEntry): boolean => {
    if (typeof link?.IsDisabled === 'boolean') {
        return link.IsDisabled
    }
    return Boolean(link?.Disabled)
}

export const splitAdvertiseLinks = (links: unknown): {
    trakheesi: IndexedAdvertiseLink[]
    portals: IndexedAdvertiseLink[]
    all: IndexedAdvertiseLink[]
} => {
    const normalized = normalizeLinksArray(links).map((link, index) => ({
        ...link,
        __sourceIndex: index
    }))

    const portals = normalized.filter((link) => isPortalLinkEntry(link))
    const trakheesi = normalized.filter((link) => !isPortalLinkEntry(link))

    return {
        trakheesi,
        portals,
        all: normalized
    }
}
